import { render, staticRenderFns } from "./AccountHeader.vue?vue&type=template&id=5abea9f3&scoped=true&"
import script from "./AccountHeader.vue?vue&type=script&lang=js&"
export * from "./AccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccountHeader.vue?vue&type=style&index=0&id=5abea9f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abea9f3",
  null
  
)

export default component.exports